import moment from 'moment';

class GtagEvent {
  startAt = null;

  /**
   * Marks the start of an event or process.
   * Use this before an operation you want to measure (e.g. order creation).
   */
  startEvent() {
    this.startAt = moment();
  }

  /**
   * Marks the end of the previously started event.
   * Returns the elapsed time in milliseconds, or -1 if the start time was never set.
   */
  finishEvent() {
    const endAt = moment();
    if (!this.startAt) {
      return -1;
    }

    const diffMs = endAt.diff(this.startAt);
    this.startAt = null;
    return diffMs;
  }

  /**
   * Adds a processing time property to the given data object.
   * If no event was started, the property is skipped.
   * Returns the same data object with optional `processing_time` included.
   */
  attachProccesingTime(data) {
    const processingTime = this.finishEvent();

    if (processingTime >= 0) {
      data.processing_time = processingTime;
    }
    return data;
  }

  /** Sends a login event */
  login(gtag) {
    gtag.event('login', {
      method: 'traditional',
    });
  }

  /*
   * To track the processing time for a purchase order,
   * call startEvent() before triggering this event.
   */
  orderCompleted(gtag, id, channel, type, itemCount) {
    const data = {
      transaction_id: id,
      channel,
      type,
      item_count: itemCount,
    };

    this.attachProccesingTime(data);
    gtag.event('order_completed', data);
  }

  /*
   * To track the processing time for a purchase order,
   * call startEvent() before triggering this event.
   */
  orderFailed(gtag, channel, type, itemCount) {
    const data = {
      channel,
      type,
      item_count: itemCount,
    };

    this.attachProccesingTime(data);
    gtag.event('order_failed', data);
  }

  /**
   * Sends a `material_search` event with details
   * about the search performed by the user.
   *
   * @param {string} type - Type of search performed ('sku' or 'text').
   */
  materialSearch(gtag, searchTerm, quantity, type) {
    gtag.event('material_search', {
      search_type: type,
      search_term: searchTerm,
      quantity,
    });
  }
}

export default new GtagEvent();
